import axios from 'axios';
import { API_GATEWAY_URL } from '../../config/api';

const instance = axios.create({
    baseURL: API_GATEWAY_URL,
    withCredentials: true
});

export default instance;
